var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    title: "done icon",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8034 2.19655C9.87451 -0.732294 5.12547 -0.732127 2.19679 2.19671C-0.732234 5.12572 -0.732234 9.8744 2.19662 12.8031C5.12547 15.7321 9.87451 15.7324 12.8034 12.8034C15.7322 9.87457 15.7322 5.12556 12.8034 2.19655ZM5.80148 11.0691L3.21029 8.47807L4.35997 7.3284L5.80131 8.76973L10.64 3.93105L11.7897 5.08072L5.80148 11.0691Z",
    fill: "#65BD69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.3abc150a7ccae04424396357a6a85543.svg";
export { ForwardRef as ReactComponent };